module.exports = __webpack_public_path__ + "static/media/slbom.3369f983.jpg";